import { render } from "./TagSelector.vue?vue&type=template&id=7f0a7734&ts=true"
import script from "./TagSelector.vue?vue&type=script&lang=ts"
export * from "./TagSelector.vue?vue&type=script&lang=ts"

import "./TagSelector.vue?vue&type=style&index=0&id=7f0a7734&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSplitter from 'quasar/src/components/splitter/QSplitter.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSplitter});
